module.exports = __webpack_public_path__ + "img/20200106155725360截图20200106105345895.8380d0bc.jpg";